/* MIRAJ universal cart (preview): live Shopify cart, no simulated prices. */
(function(){
 'use strict';
 if(window.MirajCartDrawer)return;
 const root=document.getElementById('miraj-global-cart');
 if(!root)return;
 const $=(s)=>root.querySelector(s);
 const originalFetch=window.fetch.bind(window);
 const cartUrl=root.dataset.cartUrl||'/cart';
 const addUrl=root.dataset.addUrl||'/cart/add.js';
 const changeUrl=root.dataset.changeUrl||'/cart/change.js';
 const jsonUrl=root.dataset.cartJson||'/cart.js';
 const panel=$('.mg-panel'),overlay=$('[data-mg-close].mg-overlay');
 let cartState=null,previousFocus=null,busy=false,activeIndex=0,availableRecs=[],lastRecoId=0;
 let shipTimer=null,refreshSequence=0,openSequence=0;
 const esc=(x)=>String(x??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const money=(cents)=>{const currency=(cartState&&cartState.currency)||root.dataset.currency||'USD';try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency}).format((Number(cents)||0)/100)}catch(_){return (Number(cents||0)/100).toFixed(2)+' '+currency}};
 const makeURL=(u)=>{try{return new URL(u,location.origin)}catch(_){return null}};
 function isAddRequest(input,opts){
   const raw=typeof input==='string'?input:input&&input.url;
   const url=makeURL(raw);
   const method=String(opts&&opts.method||input&&input.method||'GET').toUpperCase();
   return url&&url.origin===location.origin&&/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)&&method==='POST';
 }
 function showError(message){const node=$('[data-mg-error]');node.textContent=message||'We could not update your bag. Please try again.';node.hidden=false}
 function clearError(){$('[data-mg-error]').hidden=true}
 function hideOtherDrawers(){
   for(const el of document.querySelectorAll('cart-drawer,cart-notification')){
     try{if(typeof el.close==='function')el.close()}catch(_){}
     el.classList.remove('active');
   }
 }
 const getCart=async()=>{const res=await originalFetch(jsonUrl,{credentials:'same-origin',headers:{'Accept':'application/json'}});if(!res.ok)throw new Error('Unable to load your shopping bag');return res.json()};
 async function sync(){
   const seq=++refreshSequence;
   try{const cart=await getCart();if(seq!==refreshSequence)return;cartState=cart;render(cart);clearError();loadRecommendations(cart).catch(()=>{});}
   catch(err){if(seq===refreshSequence)showError(err.message)}
 }
 function shipping(){
   const wrap=$('[data-mg-shipping]');
   clearTimeout(shipTimer);
   wrap.classList.remove('mg-driving','mg-finished');
   $('[data-mg-progress]').setAttribute('aria-valuenow','0');
   $('[data-mg-shipping-label]').textContent='Unlocking your free shipping…';
   if(!cartState||!cartState.item_count){wrap.hidden=true;return}
   wrap.hidden=false;
   const finish=()=>{
     if(root.hidden)return;
     wrap.classList.remove('mg-driving');wrap.classList.add('mg-finished');
     $('[data-mg-progress]').setAttribute('aria-valuenow','100');
     $('[data-mg-shipping-label]').innerHTML='Congratulations! You’ve unlocked <strong>FREE shipping</strong>';
   };
   if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches){finish();return}
   void wrap.offsetWidth;
   wrap.classList.add('mg-driving');
   shipTimer=setTimeout(finish,1100);
 }
 function render(cart){
   const items=$('[data-mg-items]');
   const empty=!(cart&&cart.item_count);
   $('[data-mg-count]').textContent=cart.item_count||0;
   $('[data-mg-filled]').hidden=empty;
   $('[data-mg-empty]').hidden=!empty;
   $('[data-mg-footer]').hidden=empty;
   $('[data-mg-shipping]').hidden=empty;
   if(empty){items.replaceChildren();return}
   items.innerHTML=cart.items.map(item=>{
     const count=Math.max(1,Number(item.quantity)||1);
     const current=Number(item.final_line_price??item.line_price??0);
     const original=Number(item.original_line_price??current);
     const list=original>current;
     const discount=Math.max(0,original-current);
     const pct=original>0?Math.round(discount/original*100):0;
     const image=item.featured_image&&item.featured_image.url||item.image||'';
     const photo=image?'<img loading="lazy" src="'+esc(image)+'" alt="'+esc(item.product_title||item.title)+'">':'<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="2"/></svg>';
     const details=[];
     if(item.variant_title&&item.variant_title!=='Default Title')details.push(item.variant_title);
     Object.entries(item.properties||{}).forEach(([key,value])=>{if(key.charAt(0)!=='_'&&value!==null&&value!==''&&typeof value!=='object')details.push(key+': '+String(value))});
     const itemTitle=item.product_title||item.title;
     const url=item.url&&makeURL(item.url)?.origin===location.origin?item.url:'#';
     return '<article class="mg-item" data-mg-key="'+esc(item.key)+'">'+
       '<a class="mg-item-art" href="'+esc(url)+'">'+photo+'</a>'+
       '<div class="mg-item-info"><a class="mg-item-title" href="'+esc(url)+'">'+esc(itemTitle)+'</a>'+
       (details.length?'<p class="mg-item-detail">'+details.map(esc).join(' · ')+'</p>':'')+
       '<div class="mg-item-controls"><div class="mg-qty"><button type="button" data-mg-change="-1" aria-label="Decrease quantity">−</button><b>'+count+'</b><button type="button" data-mg-change="1" aria-label="Increase quantity">+</button></div></div></div>'+
       '<div class="mg-item-side">'+
       '<button type="button" class="mg-remove" data-mg-remove aria-label="Remove '+esc(itemTitle)+'">REMOVE</button>'+
       '<div class="mg-price-stack">'+
       (list?'<div class="mg-item-save">SAVE '+pct+'%</div>':'')+
       '<div class="mg-item-prices">'+
       (list?'<s class="mg-item-old">'+esc(money(original))+'</s>':'')+
       '<strong class="mg-item-price">'+esc(money(current))+'</strong></div>'+
       (list?'<div class="mg-item-saved">Save '+esc(money(discount))+'</div>':'')+
       '</div></div></article>';
   }).join('');
   const original=Number(cart.original_total_price??cart.items_subtotal_price??cart.total_price??0);
   const total=Number(cart.total_price??cart.items_subtotal_price??0);
   const discount=Math.max(0,Number(cart.total_discount??0),original-total);
   $('[data-mg-savings-row]').hidden=discount<=0;
   $('[data-mg-savings]').textContent=discount?'-'+money(discount):'';
   $('[data-mg-total]').textContent=money(total);
   $('[data-mg-checkout-price]').textContent=money(total);
   $('[data-mg-gaza]').textContent=money(Math.round(total*.02));
 }
 async function changeLine(key,quantity){
   if(busy)return;busy=true;clearError();
   try{
     const res=await originalFetch(changeUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
     const value=await res.json();if(!res.ok)throw Error(value.description||value.message||'Could not update your bag');
     await sync();
     document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
   }catch(e){showError(e.message)}finally{busy=false}
 }
 $('[data-mg-items]').addEventListener('click',function(event){
   const target=event.target.closest('[data-mg-change],[data-mg-remove]');
   if(!target)return;
   const line=target.closest('[data-mg-key]');if(!line||!cartState)return;
   const item=cartState.items.find(i=>i.key===line.dataset.mgKey);if(!item)return;
   const qty=target.hasAttribute('data-mg-remove')?0:Math.max(0,item.quantity+Number(target.dataset.mgChange||0));
   changeLine(item.key,qty);
 });
 function renderRecs(recs){
   availableRecs=recs;activeIndex=0;
   const section=$('[data-mg-upsell-section]');
   section.hidden=!recs.length;
   const track=$('[data-mg-upsell-track]'),dots=$('[data-mg-upsell-dots]');
   if(!recs.length){track.replaceChildren();dots.replaceChildren();return}
   track.innerHTML=recs.map(p=>'<div class="mg-upsell-slide"><div class="mg-upsell-card"><div class="mg-upsell-art">'+(p.image?'<img loading="lazy" src="'+esc(p.image)+'" alt="'+esc(p.title)+'">':'')+'</div><div class="mg-upsell-inner"><div class="mg-upsell-name">'+esc(p.title)+'</div><strong class="mg-upsell-price">'+esc(money(p.price))+'</strong></div><button type="button" class="mg-upsell-add" data-mg-variant-id="'+esc(p.variantId)+'" aria-label="Add '+esc(p.title)+'">+ ADD</button></div></div>').join('');
   dots.innerHTML=recs.map((_,i)=>'<button type="button" data-mg-slide="'+i+'" aria-label="Show recommendation '+(i+1)+'" aria-current="'+(i===0?'true':'false')+'"></button>').join('');
   updateSlider();
 }
 function updateSlider(){
   const dots=Array.from($('[data-mg-upsell-dots]').children);
   const track=$('[data-mg-upsell-track]');
   $('[data-mg-prev]').disabled=activeIndex<=0;
   $('[data-mg-next]').disabled=activeIndex>=availableRecs.length-1;
   dots.forEach((n,i)=>n.setAttribute('aria-current',String(i===activeIndex)));
   if(track.children[activeIndex])track.scrollTo({left:track.children[activeIndex].offsetLeft-track.children[0].offsetLeft,behavior:'smooth'});
 }
 function slide(i){activeIndex=Math.max(0,Math.min(i,availableRecs.length-1));updateSlider()}
 $('[data-mg-prev]').addEventListener('click',()=>slide(activeIndex-1));
 $('[data-mg-next]').addEventListener('click',()=>slide(activeIndex+1));
 $('[data-mg-upsell-dots]').addEventListener('click',e=>{const b=e.target.closest('[data-mg-slide]');if(b)slide(Number(b.dataset.mgSlide))});
 $('[data-mg-upsell-track]').addEventListener('scroll',function(){const child=this.firstElementChild;if(!child)return;let width=child.getBoundingClientRect().width+9;activeIndex=Math.min(availableRecs.length-1,Math.max(0,Math.round(this.scrollLeft/Math.max(1,width))));const dots=$('[data-mg-upsell-dots]').children;Array.from(dots).forEach((n,i)=>n.setAttribute('aria-current',String(i===activeIndex)));$('[data-mg-prev]').disabled=activeIndex===0;$('[data-mg-next]').disabled=activeIndex>=availableRecs.length-1},{passive:true});
 async function loadRecommendations(cart){
   if(!cart?.items?.length){renderRecs([]);lastRecoId=0;return}
   const current=cart.items[0].product_id;
   if(current===lastRecoId&&availableRecs.length){
     renderRecs(availableRecs.filter(p=>!cart.items.some(x=>String(x.variant_id)===String(p.variantId))));return;
   }
   lastRecoId=current;
   let recs=[];
   try{
     const rootPath=cartUrl.replace(/cart\/?$/,'');
     const response=await originalFetch(rootPath+'recommendations/products.json?product_id='+encodeURIComponent(current)+'&limit=8',{credentials:'same-origin'});
     if(response.ok){
       const payload=await response.json();
       recs=(payload.products||[]).map(p=>{const v=(p.variants||[]).find(v=>v.available);return v?{title:p.title,variantId:v.id,price:Number(v.price),image:p.featured_image||p.images?.[0]||'',productId:p.id}:null}).filter(Boolean);
     }
   }catch(_){}
   if(root.dataset.fallbackId&&!recs.some(p=>String(p.variantId)===root.dataset.fallbackId)){
     recs.push({title:root.dataset.fallbackTitle,variantId:root.dataset.fallbackId,price:Number(root.dataset.fallbackPrice),image:root.dataset.fallbackImg});
   }
   const inCart=new Set(cart.items.map(x=>String(x.variant_id)));
   const unique=new Set();recs=recs.filter(p=>{if(inCart.has(String(p.variantId))||unique.has(String(p.variantId)))return false;unique.add(String(p.variantId));return true}).slice(0,4);
   if(cartState===cart)renderRecs(recs);
 }
 $('[data-mg-upsell-track]').addEventListener('click',async e=>{
   const btn=e.target.closest('[data-mg-variant-id]');if(!btn||busy)return;
   const variantId=Number(btn.dataset.mgVariantId);if(!variantId)return;
   busy=true;btn.disabled=true;btn.textContent='ADDING…';clearError();
   try{
     const response=await originalFetch(addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:variantId,quantity:1}]})});
     const payload=await response.json();if(!response.ok)throw Error(payload.description||'Unable to add product');
     await sync();document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
   }catch(err){showError(err.message)}finally{busy=false;btn.disabled=false;btn.textContent='+ ADD'}
 });
 function closeNative(){try{document.querySelectorAll('cart-drawer,cart-notification').forEach(el=>{if(typeof el.close==='function')el.close();el.classList.remove('active')})}catch(_){}}
 async function open(restartShipping=true){
   ++openSequence;
   const wasHidden=root.hidden;
   if(wasHidden)previousFocus=document.activeElement;
   root.hidden=false;root.setAttribute('aria-hidden','false');
   document.documentElement.classList.add('miraj-cart-open');
   closeNative();
   if(wasHidden)panel.focus({preventScroll:true});
   await sync();
   // A theme callback and the global AJAX hook may both open on the same add.
   // Show the delivery animation only on the first transition from closed.
   if(restartShipping && wasHidden)shipping();
 }
 function close(){
   clearTimeout(shipTimer);root.hidden=true;root.setAttribute('aria-hidden','true');
   document.documentElement.classList.remove('miraj-cart-open');closeNative();
   if(previousFocus&&previousFocus.isConnected&&typeof previousFocus.focus==='function')previousFocus.focus({preventScroll:true});
 }
 root.addEventListener('click',e=>{if(e.target.closest('[data-mg-close]'))close()});
 root.addEventListener('keydown',e=>{
   if(e.key==='Escape'){e.preventDefault();close();return}
   if(e.key!=='Tab')return;
   const focusable=[...root.querySelectorAll('button:not([disabled]),a[href],input,select,[tabindex]:not([tabindex="-1"])')].filter(x=>!x.closest('[hidden]')&&x.getClientRects().length);
   if(!focusable.length)return;
   const first=focusable[0],last=focusable[focusable.length-1];
   if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
   else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
 });
 // Every successful AJAX add (standard Shopify forms, bundles, custom PDPs) opens this same drawer.
 window.fetch=function(input,opts){
   const promise=originalFetch(input,opts);
   if(isAddRequest(input,opts))promise.then(res=>{if(res.ok){setTimeout(()=>open(true),30)}}).catch(()=>{});
   return promise;
 };
 // Clicks on the cart icon/link use our drawer, but checkout remains a real Shopify checkout.
 document.addEventListener('click',e=>{
   if(root.contains(e.target))return;
   const link=e.target.closest('a[href]');
   if(!link)return;
   const u=makeURL(link.href);
   const c=makeURL(cartUrl);
   if(u&&c&&u.origin===location.origin&&u.pathname.replace(/\/$/,'')===c.pathname.replace(/\/$/,'')){
     e.preventDefault();open(false);
   }
 },true);
 // Older plain HTML add-to-cart forms can still work without theme JavaScript.
 document.addEventListener('submit',async e=>{
   const form=e.target;
   if(!form.matches('form[action*="/cart/add"]')||form.closest('product-form'))return;
   if(e.defaultPrevented||form.dataset.mgProcessing)return;
   e.preventDefault();form.dataset.mgProcessing='true';
   try{const response=await originalFetch(addUrl,{method:'POST',body:new FormData(form),credentials:'same-origin',headers:{'Accept':'application/json'}});const data=await response.json();if(!response.ok)throw Error(data.description||'Unable to add to cart');await open(true)}
   catch(err){showError(err.message);await open(false)}
   finally{delete form.dataset.mgProcessing}
 },false);
 document.addEventListener('cart:refresh',()=>{if(!root.hidden)sync()},false);
 window.MirajCartDrawer={open,close,refresh:sync};
})();